export default [5, 10, 20, 50]
